/*jshint -W069 */
/**
 *
 * @class Api
 * @param {(string|object)} [domainOrOptions] - The project domain or options object. If object, see the object's optional properties.
 * @param {string} [domainOrOptions.domain] - The project domain
 * @param {object} [domainOrOptions.token] - auth token - object with value property and optional headerOrQueryName and isQuery properties
 */
var Api = (function() {
  'use strict';

  var Q = require('q');
  var settingsInstance = require('./SettingsInstance.js');
  var customRequest = require('./requestHelperNew.js').customRequest;
  var mergeQueryParams = require('./requestHelperNew.js').mergeQueryParams;

  function Api(options) {
    var domain = typeof options === 'object' ? options.domain : options;
    this.domain = domain ? domain : settingsInstance.searchApiUrl;
    if (this.domain.length === 0) {
      throw new Error('Domain parameter must be specified as a string.');
    }
  }

  /**
   * HTTP Request
   * @method
   * @name Api#request
   * @param {string} method - http method
   * @param {string} path - path
   * @param {string} url
   * @param {object} body - body parameters / object
   * @param {object} headers - header parameters
   * @param {object} queryParameters - querystring parameters
   * @param {object} form - form data object
   * @param {object} deferred - promise object
   */
  Api.prototype.request = customRequest;

  /**
   * Pobierz adres na podstawie współrzędnych
   * @method
   * @name Api#getStyles
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.x - Koordynat x
   * @param {string} parameters.y - Koordynat y
   * @param {string} parameters.uklad_wspolrzednych - Układ współrzędnych
   */
  Api.prototype.searchAddressByCoordinates = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/api/searchAddressByCoordinates',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];
    headers['Content-Type'] = ['application/json'];

    if (parameters['body'] !== undefined) {
      body = parameters['body'];
    }

    this.request(
      'POST',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };

  Api.prototype.exportDemandToFile = function(target, options) {
    var deferred = Q.defer();

    var domain = settingsInstance.searchApiUrl,
      path = `/api/exportDemand${target}`,
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Content-Type'] = ['application/json'];
    switch(target) {
      case "Pdf":
        headers['Accept'] = ['application/pdf'];
        break;
      case "Csv":
        headers['Accept'] = ['text/csv'];
        break;
      case "Xlsx":
        headers['Accept'] = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
        break;
      default:
        deferred.reject(new Error('Invalid target format. Please use "Pdf", "Csv", or "Xlsx".'));
        return deferred.promise;
    }

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  return Api;
})();

exports.Api = Api;
